import * as api from "api"
import { invalid, max, regex, required } from "common/forms"
import * as yup from "yup"

type TreatmentTypesOptions = {
  id: api.TreatmentType
  name: string
}

export const treatmentTypes: TreatmentTypesOptions[] = [
  { id: "PeriodicTreatment", name: "טיפול תקופתי" },
  { id: "Problem", name: "תקלה" },
  { id: "Accident", name: "תאונה" },
]

const schema = yup
  .object({
    fullName: yup
      .string()
      .required(required.default)
      .max(...max.fullname)
      .matches(regex.fullname, invalid.fullname),
    phone: yup
      .string()
      .required(required.phoneNumber)
      .matches(regex.phoneNumber, invalid.phoneNumber),

    licenceNumber: yup
      .string()
      .required(required.licenseNumber)
      .matches(regex.licenseNumber, invalid.licenseNumber),

    treatmentDate: yup.mixed<Date>().required(required.default),
    treatmentType: yup.mixed<api.TreatmentType>().required(required.default),
  })
  .defined()

export const initialFormState: yup.InferType<typeof schema> = {
  fullName: "",
  phone: "",
  licenceNumber: "",
  treatmentDate: null,
  treatmentType: treatmentTypes[0].id,
}

export default schema
